 export const CommentVI ={
  "Comment": {
    "comment": "Bình luận",
    "like" : "Thích",
    "replyTo" : "Trả lời",
    "closeReply" : "Đóng trả lời",
    "update" : "Sửa bình luận ",
    "delete" : "Xóa bình luận",
    "cancel" : "Nhấn để hủy"
  },
  "Value": {
    "justNow": " vừa xong",
    "minutesAgo" : " phút trước",
    "daysAgo" : " ngày trước",
    "hoursAgo" : " giờ trước",
    "monthsAgo" : " tháng trước",
    "writeDiscussion" : "Nhập thảo luận......"
  },
  "InformationComment": {
    "delete": "Đã xóa bình luận ",
    "question" : " Bạn có thực sự muốn xóa bình luận này không? ",
    "information" : "XÁC NHẬN",
    "content" : "Nội dung chưa nhập" ,
    "seeMore" : "Xem thêm ",
    "olderComment": "thảo luận cũ hơn"
  },
  "emoji" : {
    "like" : "Thích",
    "heart" : "Yêu thích",
    "haha" : "Ha Ha",
    "wow" : "Wow",
    "sad" : "Buồn",
    "angry" : "Tức giận"
  }
}